import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonCategorie = () => {
    return (
        <div className="sticky top-0 z-10 bg-background">
            <div className="flex overflow-x-auto gap-4 pt-2 snap-x snap-mandatory scrollbar-hide px-4">
                {[...Array(5)].map((_, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center justify-center min-w-[80px]"
                    >
                        <Skeleton
                            circle
                            height={64}
                            width={64}
                            baseColor="#1A1F2B"
                            highlightColor="#2A2F3A"
                        />
                        <Skeleton
                            width={60}
                            height={10}
                            className="mt-2"
                            baseColor="#1A1F2B"
                            highlightColor="#2A2F3A"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SkeletonCategorie;